import {AsyncPipe} from '@angular/common'
import {Component, computed, inject, OnInit, signal, viewChild, WritableSignal} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatDialog} from '@angular/material/dialog'
import {
  MatStep,
  MatStepContent,
  MatStepLabel,
  MatStepper,
  MatStepperNext,
  MatStepperPrevious
} from '@angular/material/stepper'
import {ActivatedRoute, ParamMap} from '@angular/router'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {Plural} from '../../model/plural'
import {ControlService} from '../../services/control.service'
import {DataService} from '../../services/data.service'
import {KalpService} from '../../services/kalp.service'
import {TestService} from '../../services/test.service'
import {GeneralComponent} from '../1-general/general.component'
import {KalpComponent} from '../2-kalp/kalp.component'
import {LivingComponent} from '../3-living/living.component'
import {ExistingLoanComponent} from '../4-existingloan/existing-loan.component'
import {QuestionsComponent} from '../5-questions/questions.component'
import {PieChartComponent} from '../6a-piechart/pie-chart.component'
import {KalpResultComponent} from '../6b-0-kalp-result/kalp-result.component'
import {ProposalComponent} from '../7-proposal/proposal.component'
import {ConfirmDialogComponent} from '../8-summary/confirm-dialog/confirm-dialog.component'
import {SummaryComponent} from '../8-summary/summary.component'
import {ChartLegendComponent} from '../chart-legend/chart-legend.component'
import {ScenarioComponent} from '../scenario/scenario.component'

@Component({
  selector: 'spb-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  imports: [
    MatStepper,
    MatStep,
    MatStepLabel,
    MatStepContent,
    ScenarioComponent,
    GeneralComponent,
    MatButton,
    MatStepperNext,
    KalpComponent,
    MatStepperPrevious,
    LivingComponent,
    ExistingLoanComponent,
    QuestionsComponent,
    ChartLegendComponent,
    KalpResultComponent,
    ProposalComponent,
    SummaryComponent,
    AsyncPipe,
    PieChartComponent
  ]
})
export class MainComponent extends Plural implements OnInit {

  public kalpService = inject(KalpService)
  public controlService = inject(ControlService)
  public testService = inject(TestService)
  public dataService = inject(DataService)

  public stepper = viewChild<MatStepper>('thaStepper')

  public steps: Record<number, WritableSignal<boolean>> = {
    1: signal(false),
    2: signal(false),
    3: signal(false),
    5: signal(false),
    7: signal(false)
  }

  public hasDeclined = computed(() => this.controlService.declines())

  private readonly route = inject(ActivatedRoute)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  private readonly dialog = inject(MatDialog)

  public ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.get('id')) {
        this.dataService.populateCustomer(params.get('id') as string)
      }
    })


    this.controlService.step$
      .pipe(
        this.takeUntilDestroyed()
      )
      .subscribe((index: number) => {
        const stepper = this.stepper()
        if (stepper) {
          stepper.selectedIndex = index
        }
      })
  }

  public stepValid(valid: boolean, step: number) {
    this.steps[step]?.set(valid)
  }

  public decline() {
    this.controlService.decline(false)
    this.staticDataService.followAdvice$.next('')
  }

  public unLockAdvice(): void {
    this.dialog.open(ConfirmDialogComponent, {maxWidth: 440})
  }
}
